import { Outlet } from 'react-router-dom';
import DefaultAppHeader from './components/AppHeader/DefaultAppHeader';

export const PublicLayout = () => {
    return (
        <>
            <DefaultAppHeader />
            <Outlet />
        </>
    );
};
